export const TaxmannConstants = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    PRIVACY_POLICY: 'privacy-policy',
    RETURN_POLICY: 'return-policy',
    PAYMENT_TERMS: 'payment-terms',
    EUIA: 'end-user-licence-agreement',
    DES: 'legal-disclaimer',
    COD: 0,
}